import React from 'react';

interface BundleIconSmallProps extends React.SVGProps<SVGSVGElement> {
	className?: string;
}

/** Small Bundle brand icon (12×14) used inline in UI elements like the Summary card header */
const BundleIconSmall: React.FC<BundleIconSmallProps> = ({ className, ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="14"
		viewBox="0 0 16 14"
		fill="none"
		className={className}
		{...props}
	>
		<path
			d="M16.0014 5.84111C16.0014 2.6155 13.3564 0 10.0944 0C6.83247 0 4.1875 2.6155 4.1875 5.84111H4.19159V8.0822C4.19159 9.02093 4.96111 9.78322 5.91177 9.78322C6.86244 9.78322 7.63196 9.02227 7.63196 8.0822V5.84111H7.62787C7.62787 4.4943 8.73244 3.40204 10.0944 3.40204C11.4564 3.40204 12.561 4.4943 12.561 5.84111V13.5098H16.0014V5.84111Z"
			fill="currentColor"
		/>
		<path
			d="M10.0937 4.13287C9.14437 4.13287 8.37348 4.89382 8.37348 5.83389V8.07498C8.37348 9.42179 7.26892 10.5141 5.90693 10.5141C4.54495 10.5141 3.44037 9.42179 3.44037 8.07498V0.40625H0V8.07498C0 11.3006 2.64498 13.9161 5.90693 13.9161C9.16888 13.9161 11.8139 11.3006 11.8139 8.07498V5.83389C11.8139 4.89516 11.0443 4.13287 10.0937 4.13287Z"
			fill="currentColor"
		/>
	</svg>
);

export default BundleIconSmall;
